import { useCopyClipboard } from '@patrianna/shared-hooks'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import Button from 'components/Button'
import classes from 'components/SharingNativeMobile/styles.module.scss'
import content from 'prismic-translates/common.json'

export default function ReferFriendCopyButton({ shareUrl }: { shareUrl: string }) {
  const [isCopied, setClipboard] = useCopyClipboard(shareUrl, 3000)
  const t = getTranslationFromJson([content])

  return (
    <Button
      className={cx(classes.button)}
      onClick={setClipboard}
      variant='contained'
      size='small'
      data-test='invite-friends-copy-link-button'
    >
      {isCopied ? `✓ ${t('copied')}` : t('copy')}
    </Button>
  )
}
